export default __webpack_public_path__ + "cadfd16959242cee42bebebab21a0236.svg";